import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export async function getForecasterTweets() {
  const url = `${backendUrl}/api/forecasters/tweets/`;

  try {
    const response = await fetchWithAuth(url, {
      method: 'GET',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Ошибка при получении твитов');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API getForecasterTweets error:', error);
    throw error;
  }
}

export async function getForecasterTelegram() {
  const url = `${backendUrl}/api/forecasters/telegram/`;

  try {
    const response = await fetchWithAuth(url, {
      method: 'GET',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Ошибка при получении твитов');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API getForecasterTweets error:', error);
    throw error;
  }
}